import { render, staticRenderFns } from "./c2cIndex.vue?vue&type=template&id=12469bdb&scoped=true&"
import script from "./c2cIndex.vue?vue&type=script&lang=js&"
export * from "./c2cIndex.vue?vue&type=script&lang=js&"
import style0 from "./c2cIndex.vue?vue&type=style&index=0&id=12469bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12469bdb",
  null
  
)

export default component.exports